/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerErsUsageReportDTO } from './customer-ers-usage-report-dto';
import { ContractTypeEnumDTO } from './contract-type-enum-dto';
import { TenantUsageReportDTO } from './tenant-usage-report-dto';


export interface ContractUsageReportResponseDTO { 
    /**
     * Represents the internal id of the contract.
     */
    contractId?: string;
    /**
     * The customer identifier from the billing system this tenant is linked to.
     */
    customerIdentifier?: string;
    /**
     * Unique project number associated with the contract. Used for billing purposes.
     */
    projectNumber?: string;
    contractType?: ContractTypeEnumDTO;
    /**
     * Minimum number of contracted ERSes
     */
    contractedErses?: number;
    usage?: CustomerErsUsageReportDTO;
    tenants?: Array<TenantUsageReportDTO>;
}

export class ClsContractUsageReportResponseDTO { 
    /**
     * Represents the internal id of the contract.
     */
    contractId?: string = undefined;
    /**
     * The customer identifier from the billing system this tenant is linked to.
     */
    customerIdentifier?: string = undefined;
    /**
     * Unique project number associated with the contract. Used for billing purposes.
     */
    projectNumber?: string = undefined;
    contractType?: ContractTypeEnumDTO = undefined;
    /**
     * Minimum number of contracted ERSes
     */
    contractedErses?: number = undefined;
    usage?: CustomerErsUsageReportDTO = undefined;
    tenants?: Array<TenantUsageReportDTO> = undefined;
}



